export default {
  data() {
    return {
      form: {},
      triggerList: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: '消息类型'
        },
        dataIndex: 'auditFlowTypeName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '模板名称'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '触发条件'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 100,
        key: '6'
      }],
      tableData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  methods: {
    getDataFun() {},
    templateOperationFun() {},
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    checkedItem(val) {
      return val == 'ONLINE' ? true : false;
    },
    checkedFun(val) {
      if (!this.isAuth('home.auditFlowStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      // auditStatus({auditFlowId: val.auditFlowId,status:val.status=='ONLINE'?'OFFLINE':'ONLINE'}).then(res=>{
      //   this.$message.success('操作成功!');
      //   this.getDataFun();
      // });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该模板') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        // delAudit({auditFlowId: val.auditFlowId}).then(() => {
        //   _this.$message.success('删除成功!');
        //   _this.getDataFun();
        // });
      });
    }
  }
};